import React from 'react';
import ReactTooltip from "react-tooltip";
import BootstrapTable from 'react-bootstrap-table-next';

import Utilities from '../util/Utilities';
import RespUtils from '../util/RespUtils';
import UIUtils from '../util/UIUtils';
import MainUtils from "../main/MainUtils";
import '../styles/section.css';
import '../styles/tables.css';
import ProjectUIUtils from '../projects/ProjectUIUtils';
import RelayerUtils from './RelayerUtils';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';

class NetworkInline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chainConfig: [],
    };
  }

  async componentDidMount() {
    await RelayerUtils.loadChainConfig(this);
  }

  render() {
    return (
      <React.Fragment>
        <ReactTooltip id="main" place="top" type="dark" effect="float" multiline={true} />
        {this.props.relayers && <div>{this.renderRelayers()}</div>}
        <p>Update your (or your favorite) relayer's data at <a href="https://github.com/SmartStake/relayers" target="_blank" title="github" className="mediaCustom fab fa-github fa-md"> Github</a></p>
      </React.Fragment>
    );
  }

  renderRelayers() {
    const headerSortingClasses = (column, sortOrder, isLastSorting, colIndex) => (
      sortOrder === 'asc' ? 'sorting-asc' : 'sorting-desc'
    );

    var columns = [
      {text: "#", hidden: RespUtils.isTabletView(), dataField: "index", sort: true, headerStyle: Utilities.respWidth(5, 4, 3)},
      {text: "Relayer", dataField: "name", formatter: MainUtils.nameFormatterTableWithLogo, sort: true, headerStyle: Utilities.respWidth(45, 35, 20)},
      {text: "Contacts", hidden: RespUtils.isTabletView(), desc: "Relayer Contact Info", hidden: RespUtils.isTabletView(), dataField: "twitter", formatter: ProjectUIUtils.formatMedia, sort: true, headerStyle: Utilities.respWidth(20, 20, 15), headerSortingClasses},
      {text: "Address", hidden: RespUtils.isTabletView(), dataField: "address", formatter: RelayerUtils.relayerAddressFormatter, formatExtraData: this.state.chainConfig, sort: true, headerStyle: Utilities.respWidth(30, 30, 20)},
      {text: Utilities.respLabel("Bal", "Balance", "Balance"), dataField: "balance", formatter: RelayerUtils.formatCoins, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(12, 20, 10)},
      {text: Utilities.respLabel("8H Txs", "Txs in 8H", "Txs in 8H"), dataField: "currentDelta", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(12, 15, 10)},
      {text: "Txs in 1D", hidden: RespUtils.isMobileView(), dataField: "dailyDelta", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(25, 15, 10)},
      {text: "Txs in 7D", hidden: RespUtils.isTabletView(), dataField: "weeklyDelta", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(25, 15, 10)},
      {text: "Txs in 30D", hidden: RespUtils.isTabletView(), dataField: "monthlyDelta", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(25, 15, 10)},
    ];
    
    const options = UIUtils.getPageOptionsLarge(this, 100);

    return (
      <React.Fragment>
        <p>**Tx count shown is simply a delta change in address nonce and may be inaccurate.</p>
        <ToolkitProvider keyField='index' data={this.props.relayers} columns={columns} columnToggle>
          {
            props => (
              <div>
                <BootstrapTable options={options} { ...props.baseProps }
                    condensed noDataIndication="No Data" />
              </div>
            )
          }
        </ToolkitProvider>
      </React.Fragment>
    )
  }


}


export default NetworkInline;
